import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MigrationResult } from '../migration-result/migration-result';
import { BentoAlertItemOptions } from '@bento/bento-ng';
import { LoadComponentEventService } from '../migration-products/load-component-event.service';
import { getCompanyId } from '@onviobr/services/session';
import { MigrationDetailsService, MigrationStatusType } from '../migration-details/migration-details.service';
import { MigrationReusableService } from '../migration-reusable-components/migration-reusable.service';
import { has as hasLicense } from '@onviobr/services/licenses';
import { TranslateService } from '@ngx-translate/core';
import { MigrationSource } from '../migration-reusable-components/migration-source.enum';
import { MigrationConstants } from '../migration-reusable-components/migration-constants';

const { IN_PROGRESS, COMPLETED } = MigrationStatusType;

@Component({
	selector: 'app-migration-status',
	templateUrl: './migration-status.component.html',
	styleUrls: ['./migration-status.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class MigrationStatusComponent implements OnInit, OnDestroy {
	readonly PREPARE_FOR_MIGRATION_LINK = MigrationConstants.PREPARE_FOR_MIGRATION_LINK;
	readonly migrationSource = MigrationSource.ALL;
	public hasLicense = hasLicense;
	hasLicenseFrp = false;
	showInProgressBusyloader: boolean;
	showCompletedBusyloader: boolean;
	migrationList: Array<any>;
	inProgressMigrationData: Array<MigrationResult>;
	completedMigrationData: Array<any> = [];
	inProgressColumns: Array<any> = [];
	completedColumns: Array<any> = [];
	daysAgo = 0;
	alerts: BentoAlertItemOptions[] = [];
	lastUpdatedTimestamp: string = null;

	public getCompanyId = getCompanyId;
	companyId: string;
	migrationResultsUrl = '/api/migration-orchestrator/v1/results?companyId';
	migrationStatus = 'migrationStatus=COMPLETED';
	translations: any;

	constructor(
		private migrationDetails: MigrationDetailsService,
		public changeDetectorRef: ChangeDetectorRef,
		private loadComponentEventService: LoadComponentEventService,
		private translate: TranslateService,
		public migrationReusableService: MigrationReusableService
	) {}

	async ngOnInit() {
		this.companyId = await this.getCompanyId();
		await this.loadTranslations();
		this.hasLicenseFrp = await this.hasLicense('OnvioUS.Essentials');

		this.inProgressMigrationData = this.migrationDetails.getCachedMigrationResults(this.migrationSource, IN_PROGRESS);
		this.completedMigrationData = this.migrationDetails.getCachedMigrationResults(this.migrationSource, COMPLETED);
		this.computeLastMigratedDate(this.completedMigrationData);
		this.migrationReusableService.refreshCompletedResults();

		this.changeDetectorRef.markForCheck();
	}

	private async loadTranslations() {
		this.translations = await this.translate.get([
			'onvio.setup.migrations.dashboard',
			'onvio.setup.migrations.netclientcs',
			'onvio.setup.migrations.practicecs',
			'onvio.setup.migrations.ultrataxcs',
			'onvio.setup.migrations.thirdPartyApps'
		]).toPromise();
	}

	ngOnDestroy() {
	}

	launchProduct(item: MigrationResult): void {
		this.loadComponentEventService.navigateTab(item.migrationSource);
		this.changeDetectorRef.markForCheck();
	}

	updateInProgressMigrationStatus(event: MigrationResult[]) {
		if (event?.length) {
			this.inProgressMigrationData = event;
		} else {
			this.inProgressMigrationData = null;
		}
	}

	updateCompletedMigrationStatus(event: MigrationResult[]) {
		if (event?.length) {
			this.completedMigrationData = event;
			this.computeLastMigratedDate(this.completedMigrationData);
		} else {
			this.completedMigrationData = null;
		}
	}

	updateLastUpdatedTimestamp(event) {
		this.lastUpdatedTimestamp = event;
	}

	private computeLastMigratedDate(migrationList: Array<MigrationResult>) {
		let recentTimestamp = 0;
		let endDateInTimestamp = 0;
		if (migrationList?.length) {
			const migrationObject: MigrationResult = migrationList[0];
			endDateInTimestamp = migrationObject.migrationChangeDate;
			recentTimestamp = endDateInTimestamp > recentTimestamp ? endDateInTimestamp : recentTimestamp;

			const now = Date.now();
			const timeDiff = now - recentTimestamp;
			// To calculate the no. of days between two dates
			this.daysAgo = Math.round(timeDiff / (1000 * 3600 * 24));
		}
	}
}
